module.exports = __webpack_public_path__ + "img/package-icon.182dc36.png";